import { useState } from 'react';

import { useConfiguration } from 'contexts/country-config';
import AuthService from 'services/auth';

import AuthContext from './context';
import { ProviderProps, TwoFactorAuthData } from './types';

const AuthProvider = ({
  children,
  accessToken,
  twoFactorAuth
}: ProviderProps): JSX.Element => {
  const config = useConfiguration();
  const { api_host } = config;
  const authService = AuthService(api_host);

  const [token, setToken] = useState<string | null>(accessToken);

  const [twoFactorAuthData, setTwoFactorAuthData] = useState<TwoFactorAuthData>(
    twoFactorAuth || {}
  );

  const signIn = async (username: string, password: string, otp?: string) => {
    return authService.signIn(username, password, otp).then((data) => {
      if (data.two_factor_auth) {
        setTwoFactorAuthData({
          username: username,
          password: password
        });
      } else {
        setTwoFactorAuthData({});
        setToken(data.token);
      }
      return data;
    });
  };

  const signOut = () => {
    authService.signOut();
    setToken(null);
    // todo: invalidate all query
  };

  const forgotPassword = async (username: string) => {
    return authService.forgotPassword(username).then((data) => {
      return data;
    });
  };

  const resetPassword = async (
    username: string,
    password: string,
    token: string
  ) => {
    return authService.resetPassword(username, password, token).then((data) => {
      return data;
    });
  };

  const setPassword = async (password: string, token: string) => {
    return authService.setPassword(password, token).then((data) => {
      return data;
    });
  };

  const auth = {
    token,
    twoFactorAuthData,
    setTwoFactorAuthData,
    signIn,
    signOut,
    forgotPassword,
    resetPassword,
    setPassword
  };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
